<template>
	<div class="availability-flagged-week">
		<o-sticker>
			<div class="availability__period">
				<div class="availability__period-name">
					La semaine
				</div>
				<div class="availability__period-time">
					<o-label
						size="lg"
						:outline="setup.availableMorningWeek < 1"
						:color="setup.availableMorningWeek ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Morning, setup.week, setup.availableMorningWeek)">
						Matin
					</o-label>
					<o-label
						size="lg"
						:outline="setup.availableAfternoonWeek < 1"
						:color="setup.availableAfternoonWeek ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Afternoon, setup.week, setup.availableAfternoonWeek)">
						Après-midi
					</o-label>
					<o-label
						size="lg"
						:outline="setup.availableNightWeek < 1"
						:color="setup.availableNightWeek ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Night, setup.week, setup.availableNightWeek)">
						Nuit
					</o-label>
				</div>
			</div>

			<div class="availability__days">
				<user-profile-availability-day
					v-model="setup.availabilities.monday"
					day="monday"
					:date="setup.dayDates?.monday"
					@update:model-value="setup.updateAvailabilities()"/>
				<user-profile-availability-day
					v-model="setup.availabilities.tuesday"
					day="tuesday"
					:date="setup.dayDates?.tuesday"
					@update:model-value="setup.updateAvailabilities()"/>
				<user-profile-availability-day
					v-model="setup.availabilities.wednesday"
					day="wednesday"
					:date="setup.dayDates?.wednesday"
					@update:model-value="setup.updateAvailabilities()"/>
				<user-profile-availability-day
					v-model="setup.availabilities.thursday"
					day="thursday"
					:date="setup.dayDates?.thursday"
					@update:model-value="setup.updateAvailabilities()"/>
				<user-profile-availability-day
					v-model="setup.availabilities.friday"
					day="friday"
					:date="setup.dayDates?.friday"
					@update:model-value="setup.updateAvailabilities()"/>
			</div>
		</o-sticker>

		<o-sticker>
			<div class="availability__period">
				<div class="availability__period-name">
					Le week-end
				</div>
				<div class="availability__period-time">
					<o-label
						size="lg"
						:outline="setup.availableMorningWeekend < 1"
						:color="setup.availableMorningWeekend ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Morning, setup.weekend, setup.availableMorningWeekend)">
						Matin
					</o-label>
					<o-label
						size="lg"
						:outline="setup.availableAfternoonWeekend < 1"
						:color="setup.availableAfternoonWeekend ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Afternoon, setup.weekend, setup.availableAfternoonWeekend)">
						Après-midi
					</o-label>
					<o-label
						size="lg"
						:outline="setup.availableNightWeekend < 1"
						:color="setup.availableNightWeekend ? 'success' : 'default'"
						@click="setup.handleClickPeriod(setup.PERIOD_DAY.Night, setup.weekend, setup.availableNightWeekend)">
						Nuit
					</o-label>
				</div>
			</div>

			<div class="availability__days">
				<user-profile-availability-day
					v-model="setup.availabilities.saturday"
					day="saturday"
					:date="setup.dayDates?.saturday"
					@update:model-value="setup.updateAvailabilities()"/>
				<user-profile-availability-day
					v-model="setup.availabilities.sunday"
					day="sunday"
					:date="setup.dayDates?.sunday"
					@update:model-value="setup.updateAvailabilities()"/>
			</div>
		</o-sticker>
	</div>
</template>

<script setup lang="ts">
import UserProfileAvailabilityDay from './UserProfileAvailabilityDay.vue';
import UserProfileAvailabilityFlaggedWeekSetupService from '@/setup/user-profile/UserProfileAvailabilityFlaggedWeekSetupService';
type Emits = {(e: 'update:availabilities', val: IAvailabilityModel): void};
const emits = defineEmits<Emits>();
const props = defineProps(UserProfileAvailabilityFlaggedWeekSetupService.props);
const setup = new UserProfileAvailabilityFlaggedWeekSetupService(props, emits);
</script>

<style scoped lang="less">
@import '@/styles/variables';
.availability {
  &__period {
    display: flex;
    align-items: center;
		justify-content: space-between;
    padding: 0.5rem;

		@media @layoutNavBottom {
			flex-direction: column;
		}

    &:hover {
      background: var(--grey-lighter);
    }

    &-name {
      color: var(--grey-darker);
      text-transform: uppercase;
      font-size: 0.85rem;
      font-weight: bold;
    }

    &-time {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      > .orion-label {
        cursor: pointer;
      }
    }
  }

  &__days {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--grey-lighter);
  }
}
</style>
